import { createGlobalStyle } from "styled-components"

export const size = {
  desktop: `1152px`,
  tablet: `768px`,
  mobile: `375px`,
  phablet: `600px`
}

export const breakpoint = {
  desktop: `(min-width: ${size.desktop})`,
  desktop_down: `(max-width: ${size.desktop})`,
  tablet: `(min-width: ${size.tablet})`,
  tablet_down: `(max-width: calc(${size.tablet} - 1px))`,
  mobile: `(min-width: ${size.mobile})`,
  mobile_down: `(max-width: ${size.mobile})`,
  phablet: `(min-width: ${size.phablet})`,
}

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  html {
    overflow-y: scroll;
    scroll-behavior: smooth;
  }

  html,
  body {
    padding: 0;
    margin: 0;
    font-size: 16px;
  }

  body {
    background: var(--background);
  }

  html,
  body,
  button,
  input {
    font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Segoe UI, sans-serif;
  }

  /* ::-webkit-scrollbar {
    background-color: transparent;
    height: 5px;
    width: 5px
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 10px
  }

  ::-webkit-scrollbar-thumb {
    background-color: #dfe2e9;
    border-radius: 6px;
    cursor: pointer
  }

  ::-webkit-scrollbar-thumb:horizontal:hover,::-webkit-scrollbar-thumb:vertical:hover {
    background-color: rgba(105,123,155,.4)
  }

  ::-webkit-scrollbar-thumb:horizontal:active,::-webkit-scrollbar-thumb:vertical:active {
    background-color: #697b9b
  }

  ::-moz-placeholder,::-webkit-input-placeholder {
    color: #a9b6cb
  } */

  .swiper {
    &-button-next,
    &-button-prev {
      top: inherit;
      bottom: 3rem;
      width: 2.625rem;
      height: 2.625rem;
      &:before,
      &:after {
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        transition: all 250ms ease;
      }
      &:before {
        opacity: 0;
      }
    }
    &-button-next,
    &-container-rtl &-button-prev {
      right: 7.5rem;
      border: 2px solid rgba(0, 0, 0, 0.5);
      border-radius: 100%;
      &:before,
      &:after {
        background: rgba(0, 0, 0, 0) url(/images/next.svg) no-repeat scroll center center;
      }
      &:hover:after {
        transform: translateX(16px);
        opacity: 0;
      }
      &:before {
        transform: translateX(-16px);
      }
      &:hover:before {
        transform: translateX(0);
        opacity: 1;
      }
    }

    &-button-prev,
    &-container-rtl &-button-next {
      left: inherit;
      right: 11.5rem;
      border: 2px solid rgba(0, 0, 0, 0.5);
      border-radius: 100%;
      &:before,
      &:after {
        background: rgba(0, 0, 0, 0) url(/images/prev.svg) no-repeat scroll center center;
      }
      &:hover:after {
        transform: translateX(-16px);
        opacity: 0;
      }
      &:before {
        transform: translateX(16px);
      }
      &:hover:before {
        transform: translateX(0);
        opacity: 1;
      }
    }

    &-pagination {
      left: inherit;
      bottom: 3.5rem;
      right: 16rem;
      width: auto;
      font-size: 18px;
      line-height: 26px;
    }
    &--light &-pagination {
      color: #fff;
    }

    html &-container-horizontal > &-pagination-bullets {
      bottom: 0;
    }

    &-pagination-bullet {
      width: 12px;
      height: 12px;
      background: var(--swiper-pagination-bullet);
      border: 1px solid var(--swiper-pagination-border);
      opacity: 1;
      &-active {
        background: var(--swiper-pagination-color);
      }
    }

    html &-container-horizontal > &-pagination-bullets &-pagination-bullet {
      margin: 0 10.5px;
    }

    &--light &-button-next,
    &--light &-container-rtl &-button-prev {
      border-color: white;
      &:after,
      &:before {
        background-image: url(/images/next-light.svg);
      }
    }

    &--light &-button-prev,
    &--light &-container-rtl &-button-next {
      border-color: white;
      &:after,
      &:before {
        background-image: url(/images/prev-light.svg);
      }
    }

    &-slide {
      width: 100%;
      @media ${breakpoint.tablet} {
        width: 350px;
      }
    }
    &-pagination-fraction,
    &-button-next,
    &-button-prev {
      display: none;
      @media ${breakpoint.tablet} {
        display: inherit;
      }
    }
  }

  .carouselStaticContainer {
    .swiper-wrapper {
      @media ${breakpoint.tablet} {
        justify-content: center;
      }
    }
  }

  .featuredslide {
    padding: 0 1.5rem;
    @media ${breakpoint.tablet} {
      padding: 0;
    }
    & > div {
      height: 440px;
    }
  }

  .fakeslide {
    display: none;
    @media ${breakpoint.tablet} {
      display: block;
      width: calc(50% - (1120px / 2) - 40px);
    }
  }

  .sr-only {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  @keyframes slideright {
    from {
      transform: translateX(0);
    }

    to {
      transform: translateX(16px);
      opacity: 0;
    }
  }

  @keyframes slideleft {
    from {
      transform: translateX(0%);
    }

    to {
      transform: translateX(-16px);
      opacity: 0;
    }
  }

  @page { 
    size: auto;
    margin: 10mm 0 10mm;  
  }
  
  .cta {
    display: inline-block;
    max-width: 70vw;
    margin: 1rem 0 0;
    text-transform: uppercase;
    font-weight: bold;
    text-decoration: none;
    color: var(--text);
    font-size: 1.125rem;
    line-height: 1.5rem;
    padding-right: 3rem;
    cursor: pointer;
    background: url(/images/cta.svg) no-repeat right center;
    @media ${breakpoint.desktop} {
      background-image: url(/images/cta.svg);
    }
    transition: padding-right 350ms ease;
    @media (hover: hover) {
      &:hover {
        padding-right: 4rem;
      }
    }
    span {
      display: none;
    }    
  }

  input.cta {
    border: 2px #000 solid;
  }

  html.popup-open{
    overflow: hidden;
  }

  html.filter-open header {
    z-index: 0;
  }

  .ps-widget {
    .ps-header-container.ps-float-box {
        z-index: 0
    }
  }

`

export default GlobalStyles